import React from 'react';
import { content } from './SellerLabel.style';
import Box from '@mui/material/Box';
import { FrenchFlagIcon } from '@rakutenfrance/shared-svg';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { colorPalette } from '../../../colorPalette';
export const SellerLabel = ({ label, isFrench }) => {
    return (React.createElement(Stack, { component: "span", sx: content, "data-qa": "seller-label", direction: "row" },
        isFrench && (React.createElement(Box, { marginRight: "4px", display: "flex", alignItems: "center" },
            React.createElement(FrenchFlagIcon, { width: "15", height: "9" }))),
        React.createElement(Typography, { sx: {
                fontSize: '12px',
                fontWeight: 600,
                color: colorPalette.gray800,
            } }, label)));
};
